document.addEventListener('DOMContentLoaded', function () {

  /* ============ Fixed header + announcement bar heights (both pinned to top, always) ============ */
  var siteHeader = document.querySelector('.site-header');
  var announcementBar = document.querySelector('.announcement-bar');
  function updateHeaderHeightVar() {
    var announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');
    if (siteHeader) document.documentElement.style.setProperty('--header-height', siteHeader.offsetHeight + 'px');
  }
  updateHeaderHeightVar();
  window.addEventListener('resize', updateHeaderHeightVar);

  /* ============ Footer accordions — force open on desktop, native collapsed on mobile ============ */
  var footerAccordions = document.querySelectorAll('.footer-accordion');
  var DESKTOP_BREAKPOINT = 900;
  function syncFooterAccordions() {
    var isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    footerAccordions.forEach(function (details) {
      if (isDesktop) {
        details.open = true;
      } else if (!details.dataset.userToggled) {
        details.open = false;
      }
    });
  }
  footerAccordions.forEach(function (details) {
    details.addEventListener('toggle', function () { details.dataset.userToggled = 'true'; });
    var summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) e.preventDefault();
      });
    }
  });
  syncFooterAccordions();
  window.addEventListener('resize', syncFooterAccordions);

  /* ============ Product info accordion — smooth open/close height animation, one open at a time ============ */
  document.querySelectorAll('.product-tabs').forEach(function (tabs) {
    var items = Array.prototype.slice.call(tabs.querySelectorAll('details.product-tabs__item'));

    items.forEach(function (details) {
      var summary = details.querySelector('summary');
      var content = details.querySelector('.product-tabs__content');
      if (!summary || !content) return;
      var isClosing = false;

      function closedHeight() {
        var style = getComputedStyle(details);
        return summary.offsetHeight + (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
      }

      function openAnimated() {
        details.style.height = closedHeight() + 'px';
        details.open = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            details.style.height = (closedHeight() + content.offsetHeight) + 'px';
          });
        });
      }

      function closeAnimated() {
        if (!details.open || isClosing) return;
        isClosing = true;
        details.style.height = details.offsetHeight + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            details.style.height = closedHeight() + 'px';
          });
        });
      }
      details._cpfCloseAnimated = closeAnimated;

      details.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'height') return;
        if (isClosing) {
          details.open = false;
          details.style.height = '';
          isClosing = false;
        } else if (details.open) {
          details.style.height = 'auto';
        }
      });

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.open) {
          closeAnimated();
        } else {
          items.forEach(function (other) {
            if (other !== details && other.open && other._cpfCloseAnimated) other._cpfCloseAnimated();
          });
          openAnimated();
        }
      });
    });
  });

  /* ============ Mobile menu ============ */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ============ Header predictive search dropdown ============ */
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchToggles = document.querySelectorAll('[data-search-toggle]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchTimer = null;

  function openSearchPanel() {
    if (!searchPanel) return;
    searchPanel.hidden = false;
    searchToggles.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    if (searchInput) { searchInput.focus(); }
  }
  function closeSearchPanel() {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    searchToggles.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
  }
  if (searchPanel) {
    searchToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (searchPanel.hidden) { openSearchPanel(); } else { closeSearchPanel(); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hidden) closeSearchPanel();
    });
    document.addEventListener('click', function (e) {
      if (searchPanel.hidden) return;
      if (searchPanel.contains(e.target)) return;
      var clickedToggle = false;
      searchToggles.forEach(function (btn) { if (btn.contains(e.target)) clickedToggle = true; });
      if (!clickedToggle) closeSearchPanel();
    });
  }
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (query.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () { runPredictiveSearch(query); }, 250);
    });
  }
  function runPredictiveSearch(query) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderSearchResults(products, query);
      })
      .catch(function () { searchResults.innerHTML = ''; });
  }
  function renderSearchResults(products, query) {
    if (!products.length) {
      searchResults.innerHTML = '<p class="site-header__search-empty">No results found for &ldquo;' + escapeHtml(query) + '&rdquo;.</p>';
      return;
    }
    var html = products.map(function (product) {
      var image = product.image || (product.featured_image && product.featured_image.url) || '';
      return (
        '<a class="site-header__search-result" href="' + product.url + '">' +
        (image ? '<img src="' + image + '" alt="" width="48" height="48">' : '<img alt="" width="48" height="48">') +
        '<span class="site-header__search-result-title">' + escapeHtml(product.title) + '</span>' +
        '<span class="site-header__search-result-price">' + (product.price || '') + '</span>' +
        '</a>'
      );
    }).join('');
    html += '<a class="site-header__search-viewall" href="/search?q=' + encodeURIComponent(query) + '">View all results for &ldquo;' + escapeHtml(query) + '&rdquo; &rarr;</a>';
    searchResults.innerHTML = html;
  }

  /* ============ Cart drawer open/close ============ */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOpeners = document.querySelectorAll('[data-cart-drawer-open]');
  var cartClosers = document.querySelectorAll('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  cartOpeners.forEach(function (el) { el.addEventListener('click', openCartDrawer); });
  cartClosers.forEach(function (el) { el.addEventListener('click', closeCartDrawer); });

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ============ Crew perks: tiered discount + free ebook, based on the TOTAL quantity
     currently in the cart (excluding the ebook itself) — not tied to any single "Add to Cart"
     click. This is what makes it work no matter how the items got there: picking a Crew Deal,
     adding items one at a time across several visits, or editing quantities in the cart.
     Re-checked every time the cart is fetched/rendered (see applyCartToDrawer below), so it
     self-corrects on every page load and every cart change. ============ */
  var FREE_EBOOK_VARIANT_ID = 53655275962647; // "Team Growth Playbook" — see /products/team-growth-playbook
  var CREW_TIERS = [
    { min: 10, code: 'CREW10', ebook: true },
    { min: 5, code: 'CREW5', ebook: true },
    { min: 3, code: 'CREW3', ebook: false }
  ];
  // Ornament products have their own tiers, counted separately from apparel (a cart with 5
  // ornaments + 3 shirts gets ORN5 on the ornaments and CREW3 on the shirts). Every ornament
  // tier also adds the free ebook. Free shipping comes from the store's $100+ free shipping
  // rate, not a code. The ORN* codes only apply to the "Ornaments" collection in Shopify
  // admin, so they never touch apparel lines.
  var ORNAMENT_TIERS = [
    { min: 20, code: 'ORN20', ebook: true },
    { min: 15, code: 'ORN15', ebook: true },
    { min: 10, code: 'ORN10', ebook: true },
    { min: 5, code: 'ORN5', ebook: true }
  ];
  // Job-site signs / banners: own tier group (counted separately, like ornaments). Packs of
  // 3 / 5 / 10 → 10 / 11 / 12% off via the SIGN3 / SIGN5 / SIGN10 codes, which must exist in
  // Shopify admin and apply only to the sign products. 5+ also adds the free ebook.
  var SIGN_TIERS = [
    { min: 10, code: 'SIGN10', ebook: true },
    { min: 5, code: 'SIGN5', ebook: true },
    { min: 3, code: 'SIGN3', ebook: false }
  ];
  var cartPerksSyncing = false;

  function pickTier(tiers, qty) {
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min) return tiers[i];
    }
    return null;
  }

  function desiredCrewTier(qty) {
    return pickTier(CREW_TIERS, qty);
  }

  function isOrnamentItem(item) {
    if (item.properties && item.properties._tier_group === 'ornament') return true;
    return String(item.product_type || '').toLowerCase().indexOf('ornament') !== -1;
  }

  function isSignItem(item) {
    return !!(item.properties && item.properties._tier_group === 'sign');
  }

  // Apparel ("crew") quantity — everything except the free ebook and ornaments (which have
  // their own tiers). Same count as before for apparel-only carts.
  function realItemQty(cart) {
    return cart.items.reduce(function (sum, item) {
      if (item.variant_id === FREE_EBOOK_VARIANT_ID || isOrnamentItem(item) || isSignItem(item)) return sum;
      return sum + item.quantity;
    }, 0);
  }

  function ornamentItemQty(cart) {
    return cart.items.reduce(function (sum, item) {
      return isOrnamentItem(item) ? sum + item.quantity : sum;
    }, 0);
  }

  function signItemQty(cart) {
    return cart.items.reduce(function (sum, item) {
      return isSignItem(item) ? sum + item.quantity : sum;
    }, 0);
  }

  // All tier codes the cart should carry right now, e.g. ['CREW5'] or ['CREW3', 'ORN10'].
  function desiredPerkCodes(cart) {
    var codes = [];
    var crewTier = desiredCrewTier(realItemQty(cart));
    var ornTier = pickTier(ORNAMENT_TIERS, ornamentItemQty(cart));
    var signTier = pickTier(SIGN_TIERS, signItemQty(cart));
    if (crewTier) codes.push(crewTier.code);
    if (ornTier) codes.push(ornTier.code);
    if (signTier) codes.push(signTier.code);
    return { codes: codes, ebook: !!((crewTier && crewTier.ebook) || (ornTier && ornTier.ebook) || (signTier && signTier.ebook)) };
  }

  function syncCartPerks(cart) {
    if (cartPerksSyncing) return;
    var desired = desiredPerkCodes(cart);
    var wantEbook = desired.ebook;
    var wantCode = desired.codes.join(',');
    var hasEbook = cart.items.some(function (item) { return item.variant_id === FREE_EBOOK_VARIANT_ID; });
    var currentCode = (cart.discount_codes || []).map(function (d) { return d.code; }).join(',');

    var needsEbookAdd = wantEbook && !hasEbook;
    var needsEbookRemove = !wantEbook && hasEbook;
    var needsDiscountChange = wantCode.toUpperCase() !== currentCode.toUpperCase();
    if (!needsEbookAdd && !needsEbookRemove && !needsDiscountChange) return;

    cartPerksSyncing = true;
    // One request does it all: /cart/update.js takes the ebook quantity (by variant id —
    // adds it when missing, 0 removes it) and the discount code together, and returns the
    // updated cart so there's no extra /cart.js round trip.
    var payload = {};
    if (needsEbookAdd || needsEbookRemove) {
      payload.updates = {};
      payload.updates[FREE_EBOOK_VARIANT_ID] = needsEbookAdd ? 1 : 0;
    }
    if (needsDiscountChange) payload.discount = wantCode;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.ok ? r.json() : fetch('/cart.js').then(function (r2) { return r2.json(); }); })
      .then(function (freshCart) {
        cartPerksSyncing = false;
        applyCartToDrawer(freshCart);
      })
      .catch(function () { cartPerksSyncing = false; });
  }

  function renderCartDrawerHtml(cart) {
    if (cart.item_count === 0) {
      return '<p class="cart-drawer-empty">Your cart is empty.</p>';
    }
    // Keep each item's real cart line number (its original position) so the qty/remove
    // controls still target the correct line, but always display the free ebook gift last.
    var indexed = cart.items.map(function (item, index) { return { item: item, line: index + 1 }; });
    function displayRank(item) {
      if (item.variant_id === FREE_EBOOK_VARIANT_ID) return 2;
      if (item.properties && item.properties._addon === 'hat') return 1;
      return 0;
    }
    indexed.sort(function (a, b) { return displayRank(a.item) - displayRank(b.item); });
    var rows = indexed.map(function (entry) {
      var item = entry.item;
      var line = entry.line;
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          var val = item.properties[key];
          if (val && key.charAt(0) !== '_') {
            props += '<div class="cart-drawer-item__prop"><strong>' + escapeHtml(key) + ':</strong> ' +
              (typeof val === 'string' && val.indexOf('http') === 0 ? 'file attached' : escapeHtml(String(val))) + '</div>';
          }
        });
      }
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-drawer-item__variant">' + escapeHtml(item.variant_title.replace(/\s*\/\s*/g, ' · ')) + '</div>'
        : '';
      return (
        '<div class="cart-drawer-item" data-cart-drawer-line-row data-line="' + line + '">' +
        '<img class="cart-drawer-item__image" src="' + item.image + '" alt="">' +
        '<div class="cart-drawer-item__body">' +
        '<div class="cart-drawer-item__head">' +
        '<div class="cart-drawer-item__title">' + escapeHtml(item.product_title) + '</div>' +
        '<button type="button" class="cart-drawer-item__remove" data-cart-drawer-remove data-line="' + line + '" aria-label="Remove">&times;</button>' +
        '</div>' +
        variantLabel +
        props +
        '<div class="cart-drawer-item__footer">' +
        '<div class="quantity-stepper quantity-stepper--sm">' +
        '<button type="button" data-cart-drawer-qty-minus data-line="' + line + '" aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" min="0" value="' + item.quantity + '" data-cart-drawer-qty-input data-line="' + line + '">' +
        '<button type="button" data-cart-drawer-qty-plus data-line="' + line + '" aria-label="Increase quantity">&plus;</button>' +
        '</div>' +
        '<div class="cart-drawer-item__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div></div></div>'
      );
    }).join('');

    // "Amount off products" discount codes apply per line item (cart.items[].discounts), not
    // cart.cart_level_discount_applications (that's only for cart-wide/shipping discounts) — aggregate both.
    var discountTotals = {};
    cart.items.forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        discountTotals[d.title] = (discountTotals[d.title] || 0) + d.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      discountTotals[d.title] = (discountTotals[d.title] || 0) + d.total_allocated_amount;
    });
    var discountTitles = Object.keys(discountTotals);

    var discountRows = discountTitles.map(function (title) {
      return '<div class="cart-page__discount" data-cart-discount>' +
        '<span>🏷 ' + escapeHtml(title) + ' (&minus;' + formatMoney(discountTotals[title]) + ')</span>' +
        '<button type="button" class="cart-page__discount-remove" data-cart-discount-remove aria-label="Remove discount">&times;</button>' +
        '</div>';
    }).join('');

    var appliedCode = discountTitles.length ? discountTitles[0] : '';
    if (!appliedCode) {
      // No confirmed applied discount yet (e.g. sync request still in flight) — show the
      // intended tier code as a hint so the box never just sits there blank.
      var hintCodes = desiredPerkCodes(cart).codes;
      if (hintCodes.length) appliedCode = hintCodes.join(', ');
    }

    var utilsHtml =
      '<div class="cart-drawer-coupon-row">' +
      '<input type="text" class="cpf-input" placeholder="Discount code" value="' + escapeHtml(appliedCode) + '" data-cart-coupon-input>' +
      '<button type="button" class="btn btn--secondary" data-cart-coupon-apply>Apply</button>' +
      '</div>' +
      '<div class="cart-drawer-utils">' +
      '<button type="button" class="cart-drawer-utils__btn" data-cart-util-toggle="note">✎ Order note</button>' +
      '</div>' +
      '<div class="cart-drawer-util-panel" data-cart-util-panel="note" hidden>' +
      '<textarea class="cpf-textarea" rows="2" placeholder="Add a note to your order" data-cart-note-input>' + escapeHtml(cart.note || '') + '</textarea>' +
      '<button type="button" class="btn btn--secondary btn--full" data-cart-note-save>Save note</button>' +
      '</div>';

    return (
      rows +
      discountRows +
      '<div class="cart-drawer-subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      utilsHtml +
      '<a href="/cart" class="btn btn--secondary btn--full" style="margin:12px 0 8px;">View cart</a>' +
      '<a href="/checkout" class="btn btn--primary btn--full">Check out</a>'
    );
  }

  function refreshCartDrawer() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(applyCartToDrawer)
      .catch(function () {});
  }

  function applyCartToDrawer(cart) {
    var body = document.getElementById('CartDrawerBody');
    if (body) body.innerHTML = renderCartDrawerHtml(cart);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    syncCartPerks(cart);
    return cart;
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(applyCartToDrawer)
      .catch(function () {});
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cart-drawer-remove]');
      if (removeBtn) {
        changeCartLine(removeBtn.getAttribute('data-line'), 0);
        return;
      }
      var stepBtn = e.target.closest('[data-cart-drawer-qty-minus], [data-cart-drawer-qty-plus]');
      if (stepBtn) {
        var line = stepBtn.getAttribute('data-line');
        var input = cartDrawer.querySelector('[data-cart-drawer-qty-input][data-line="' + line + '"]');
        if (!input) return;
        var value = parseInt(input.value, 10) || 0;
        value = stepBtn.hasAttribute('data-cart-drawer-qty-minus') ? Math.max(0, value - 1) : value + 1;
        changeCartLine(line, value);
        return;
      }
      if (e.target.closest('[data-cart-discount-remove]')) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        }).then(function (r) { return r.json(); }).then(applyCartToDrawer).catch(function () {});
        return;
      }

      var utilToggle = e.target.closest('[data-cart-util-toggle]');
      if (utilToggle) {
        var panel = cartDrawer.querySelector('[data-cart-util-panel="' + utilToggle.getAttribute('data-cart-util-toggle') + '"]');
        if (panel) panel.hidden = !panel.hidden;
        return;
      }

      if (e.target.closest('[data-cart-note-save]')) {
        var noteInput = cartDrawer.querySelector('[data-cart-note-input]');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteInput ? noteInput.value : '' })
        }).then(function (r) { return r.json(); }).then(applyCartToDrawer).catch(function () {});
        return;
      }

      if (e.target.closest('[data-cart-coupon-apply]')) {
        var couponInput = cartDrawer.querySelector('[data-cart-coupon-input]');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: couponInput ? couponInput.value : '' })
        }).then(function (r) { return r.json(); }).then(applyCartToDrawer).catch(function () {});
      }
    });

    cartDrawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-drawer-qty-input]')) {
        var value = Math.max(0, parseInt(e.target.value, 10) || 0);
        changeCartLine(e.target.getAttribute('data-line'), value);
      }
    });
  }

  refreshCartDrawer();

  // If the browser restores this page from its back/forward cache (e.g. a customer hits
  // checkout, doesn't complete it, then taps the browser Back button), force a real reload
  // instead of showing the stale cached page. Shopify's checkout can leave the cart/checkout
  // session in a state the cached page's cart drawer doesn't reflect, and a fresh load is the
  // most reliable way to pick up whatever the cart actually looks like now.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) window.location.reload();
  });

  /* ============ Cart page quantity buttons (AJAX update) ============ */
  document.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = this.getAttribute('data-line');
      var input = document.querySelector('[data-cart-qty-input][data-line="' + line + '"]');
      if (!input) return;
      var value = parseInt(input.value, 10) || 0;
      value = this.hasAttribute('data-cart-qty-minus') ? Math.max(0, value - 1) : value + 1;
      input.value = value;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: value })
      })
        .then(function () { window.location.reload(); })
        .catch(function () {});
    });
  });

  /* ============ Cart page: "Update cart" / "Check out" — bypass the native updates[line]=qty
     bulk form submit. Shopify's classic /cart endpoint 422s with "Cannot find variant" when that
     bulk update runs against a cart that has a per-line ("Amount off products") discount applied
     (confirmed directly against the live cart API) — /cart/change.js one line at a time doesn't
     have that problem, so we replicate "Update"/"Checkout" using that instead. ============ */
  var cartPageForm = document.querySelector('[data-cart-page-form]');
  if (cartPageForm) {
    function applyCartPageQtyChanges() {
      var chain = Promise.resolve();
      cartPageForm.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
        var current = String(parseInt(input.value, 10) || 0);
        if (current === input.defaultValue) return;
        var line = input.getAttribute('data-line');
        chain = chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(current, 10) })
          });
        });
      });
      return chain;
    }

    // Bind directly to each button's click (rather than the form's submit + event.submitter)
    // since submitter tracking isn't reliably picked up here — a plain click listener per
    // button is unambiguous about which action the shopper asked for.
    var updateBtn = cartPageForm.querySelector('button[name="update"]');
    var checkoutBtn = cartPageForm.querySelector('button[name="checkout"]');
    if (updateBtn) {
      updateBtn.addEventListener('click', function (e) {
        e.preventDefault();
        applyCartPageQtyChanges()
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      });
    }
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        applyCartPageQtyChanges()
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { window.location.href = '/checkout'; });
      });
    }
  }

  /* ============ Cart page — remove an applied discount code ============ */
  document.querySelectorAll('[data-cart-discount-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .then(function () { window.location.reload(); })
        .catch(function () {});
    });
  });

  /* ============ Product gallery — draggable + swipeable + thumbnails + looping arrows ============ */
  var galleryControllers = {};

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery, galleryIndex) {
    var scroller = gallery.querySelector('[data-gallery-scroller]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (!scroller || slides.length === 0) return;

    function goToIndex(index, instant) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      var target = slides[index];
      if (target) scroller.scrollTo({ left: target.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }

    function currentIndex() {
      var scrollLeft = scroller.scrollLeft;
      var width = scroller.clientWidth || 1;
      return Math.round(scrollLeft / width);
    }

    function setActiveThumb(index) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === index);
      });
    }

    function goToMediaId(mediaId) {
      var slide = gallery.querySelector('[data-gallery-slide][data-media-id="' + mediaId + '"]');
      if (!slide) return;
      // Switching Style/garment should show that photo right away, not slide through every image in between.
      goToIndex(parseInt(slide.getAttribute('data-index'), 10), true);
    }

    var galleryId = gallery.getAttribute('data-product-gallery') || ('gallery-' + galleryIndex);
    galleryControllers[galleryId] = { goToMediaId: goToMediaId };
    if (galleryIndex === 0) galleryControllers.primary = { goToMediaId: goToMediaId };

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToIndex(parseInt(this.getAttribute('data-index'), 10));
      });
    });

    // Looping arrows: wrap from last slide back to first and vice versa.
    if (prevBtn) prevBtn.addEventListener('click', function () {
      goToIndex((currentIndex() - 1 + slides.length) % slides.length);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      goToIndex((currentIndex() + 1) % slides.length);
    });

    var scrollTimer;
    scroller.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { setActiveThumb(currentIndex()); }, 80);
    });

    // Wrap only applies when the gesture STARTS already at the last/first slide — so a
    // swipe that merely arrives there lands normally, and you need a second swipe to wrap.
    var WRAP_THRESHOLD = 24;
    function landAfterGesture(startIndex, dx) {
      if (startIndex === slides.length - 1 && dx < -WRAP_THRESHOLD) {
        goToIndex(0);
      } else if (startIndex === 0 && dx > WRAP_THRESHOLD) {
        goToIndex(slides.length - 1);
      } else {
        goToIndex(currentIndex());
      }
    }

    // Drag-to-scroll for BOTH mouse and touch — JS owns the whole gesture (CSS
    // `touch-action: pan-y` stops the browser from taking over horizontal scrolling and
    // canceling our pointer events mid-swipe), so the slide follows the finger 1:1 and
    // the end-of-gesture math is always based on a position we actually set ourselves.
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var dragStartIndex = 0;
    var didDrag = false;

    scroller.addEventListener('pointerdown', function (e) {
      isDragging = true;
      didDrag = false;
      dragStartX = e.clientX;
      dragStartScrollLeft = scroller.scrollLeft;
      dragStartIndex = currentIndex();
      scroller.classList.add('is-dragging');
      scroller.setPointerCapture(e.pointerId);
    });

    scroller.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 3) didDrag = true;
      scroller.scrollLeft = dragStartScrollLeft - dx;
    });

    function endDrag(e) {
      if (!isDragging) return;
      isDragging = false;
      scroller.classList.remove('is-dragging');
      landAfterGesture(dragStartIndex, e.clientX - dragStartX);
    }
    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('pointerleave', function (e) { if (isDragging) endDrag(e); });

    // Suppress the click-through on a slide/thumb right after a drag.
    scroller.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);
  });

  /* ============ Quantity stepper ("how many sets") ============ */
  document.querySelectorAll('.product-form__quantity').forEach(function (wrapper) {
    var input = wrapper.querySelector('[data-qty-input]');
    var minus = wrapper.querySelector('[data-qty-minus]');
    var plus = wrapper.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  /* ============ Testimonials carousel — prev/next scroll by one card + drag-to-scroll ============ */
  document.querySelectorAll('[data-testimonials]').forEach(function (section) {
    var track = section.querySelector('[data-testimonials-track]');
    var prevBtn = section.querySelector('[data-testimonials-prev]');
    var nextBtn = section.querySelector('[data-testimonials-next]');
    if (!track) return;
    function scrollByCard(direction) {
      var card = track.querySelector('.testimonial-card');
      var amount = card ? card.getBoundingClientRect().width + 20 : 280;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    // Drag-to-scroll for both mouse and touch (same approach as the product gallery).
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var didDrag = false;

    track.addEventListener('pointerdown', function (e) {
      isDragging = true;
      didDrag = false;
      dragStartX = e.clientX;
      dragStartScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 3) didDrag = true;
      track.scrollLeft = dragStartScrollLeft - dx;
    });
    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', function () { if (isDragging) endDrag(); });
    track.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);
  });

  /* ============ Upload filename + image preview display ============ */
  document.querySelectorAll('.cpf-file-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var wrapper = this.closest('.cpf-upload');
      var label = wrapper.querySelector('[data-upload-filename]');
      var preview = wrapper.querySelector('[data-upload-preview]');
      var file = (this.files && this.files.length > 0) ? this.files[0] : null;

      if (label) {
        label.textContent = this.files && this.files.length > 0
          ? Array.prototype.map.call(this.files, function (f) { return f.name; }).join(', ')
          : 'No file chosen';
      }

      if (preview) {
        if (file && file.type.indexOf('image/') === 0) {
          preview.src = URL.createObjectURL(file);
          preview.hidden = false;
        } else {
          preview.hidden = true;
          preview.removeAttribute('src');
        }
      }
    });
  });

  /* ============ Top style/size pill picker — mirrors crew-member row #1 ============ */
  var variantPicker = document.querySelector('[data-variant-picker]');

  function syncVariantPicker(garmentValue, sizeValue) {
    if (!variantPicker) return;
    [['garment', garmentValue], ['size', sizeValue]].forEach(function (pair) {
      var key = pair[0], value = pair[1];
      if (value == null) return;
      var group = variantPicker.querySelector('[data-variant-picker-pills="' + key + '"]');
      var label = variantPicker.querySelector('[data-variant-picker-label="' + key + '"]');
      if (label) label.textContent = value;
      if (!group) return;
      group.querySelectorAll('.pill').forEach(function (pill) {
        pill.classList.toggle('is-active', pill.getAttribute('data-value') === value);
      });
    });
  }

  if (variantPicker) {
    variantPicker.querySelectorAll('[data-variant-picker-pills] .pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('[data-variant-picker-pills]');
        var key = group.getAttribute('data-variant-picker-pills');
        var firstRow = document.querySelector('.cpf-combo-row');
        if (!firstRow) return;
        var select = firstRow.querySelector(key === 'garment' ? '[data-row-garment]' : '[data-row-size]');
        if (!select) return;
        select.value = pill.getAttribute('data-value');
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ============ Combo / crew deal dynamic rows (#1..#N) + live pricing ============ */
  document.querySelectorAll('.custom-product-form').forEach(function (cpfRoot) {
    var comboEl = cpfRoot.querySelector('[data-combo-selector]');
    if (!comboEl) return;

    var rowsContainer = comboEl.querySelector('[data-combo-rows]');
    var template = comboEl.querySelector('#CPF-Row-Template');
    var radios = comboEl.querySelectorAll('[data-combo-count]');
    var totalEl = comboEl.querySelector('[data-combo-total]');

    var formEl = cpfRoot.closest('form');
    var addBtnText = formEl ? formEl.querySelector('[data-add-to-cart-text]') : null;
    var qtyInput = formEl ? formEl.querySelector('[data-qty-input]') : null;

    function updateAddToCartLabel() {
      if (!addBtnText) return;
      var rowCount = rowsContainer.querySelectorAll('.cpf-combo-row').length || 1;
      var sets = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      addBtnText.textContent = 'Add ' + (rowCount * sets) + ' To Cart';
    }
    if (qtyInput) qtyInput.addEventListener('input', updateAddToCartLabel);

    var garmentOptionIndex = parseInt(cpfRoot.getAttribute('data-garment-option-index'), 10);
    var sizeOptionIndex = parseInt(cpfRoot.getAttribute('data-size-option-index'), 10);

    var variantsJsonEl = document.getElementById('ProductVariantsJson');
    var variants = [];
    try { variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : []; } catch (e) { variants = []; }

    function optionValueAt(variant, index) {
      if (index === 0) return variant.option1;
      if (index === 1) return variant.option2;
      if (index === 2) return variant.option3;
      return null;
    }

    function findVariant(garmentValue, sizeValue) {
      return variants.find(function (v) {
        var g = garmentOptionIndex > -1 ? optionValueAt(v, garmentOptionIndex) : null;
        var s = sizeOptionIndex > -1 ? optionValueAt(v, sizeOptionIndex) : null;
        var garmentOk = garmentOptionIndex === -1 || g === garmentValue;
        var sizeOk = sizeOptionIndex === -1 || s === sizeValue;
        return garmentOk && sizeOk;
      });
    }

    function updateRowPricing() {
      var rows = rowsContainer.querySelectorAll('.cpf-combo-row');
      var total = 0;
      rows.forEach(function (row, rowIndex) {
        var garmentSelect = row.querySelector('[data-row-garment]');
        var sizeSelect = row.querySelector('[data-row-size]');
        var priceEl = row.querySelector('[data-row-price]');
        var variant = findVariant(garmentSelect ? garmentSelect.value : null, sizeSelect ? sizeSelect.value : null);
        if (variant) {
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          total += variant.price;
          row.setAttribute('data-variant-id', variant.id);
          row.setAttribute('data-available', variant.available ? '1' : '0');
          if (!variant.available && priceEl) priceEl.textContent += ' (sold out)';
          // Row #1 drives the main gallery image and the top price/style picker, same as a normal variant picker.
          if (rowIndex === 0) {
            if (galleryControllers.primary) {
              var mediaId = (variant.featured_image && variant.featured_image.id) || variant.image_id;
              if (mediaId) galleryControllers.primary.goToMediaId(mediaId);
            }
            var priceWrap = document.querySelector('[data-product-price]');
            if (priceWrap) {
              var compareEl = priceWrap.querySelector('.price--compare');
              var saleEl = priceWrap.querySelector('.price--sale');
              if (saleEl) saleEl.textContent = formatMoney(variant.price);
              if (compareEl) {
                if (variant.compare_at_price > variant.price) {
                  compareEl.textContent = formatMoney(variant.compare_at_price);
                  compareEl.hidden = false;
                } else {
                  compareEl.hidden = true;
                }
              }
            }
            syncVariantPicker(garmentSelect ? garmentSelect.value : null, sizeSelect ? sizeSelect.value : null);
          }
        } else if (priceEl) {
          priceEl.textContent = '';
          row.removeAttribute('data-variant-id');
        }
      });
      if (totalEl) {
        // Show the real mixed-size total after the bundle tier the cart will apply (same tier
        // list as the deal cards), e.g. "Total: $264.61 (8% off $287.62)".
        var totalLabel = cpfRoot.getAttribute('data-tier-group') === 'crew' ? 'Crew total' : 'Total';
        var totalTiers = [];
        try { totalTiers = JSON.parse(cpfRoot.getAttribute('data-combo-tiers') || '[]'); } catch (e) {}
        var totalPercent = 0;
        totalTiers.forEach(function (t) { if (rows.length >= t.min && t.percent > totalPercent) totalPercent = t.percent; });
        // Shopify takes a percentage discount off each unit and rounds that down to the cent,
        // so mirror it per row to land on exactly the checkout total.
        var totalAfter = 0;
        rows.forEach(function (row) {
          var v = variants.find(function (x) { return String(x.id) === row.getAttribute('data-variant-id'); });
          if (v) totalAfter += v.price - Math.floor(v.price * totalPercent / 100);
        });
        totalEl.textContent = rows.length > 1
          ? totalLabel + ': ' + formatMoney(totalAfter) + (totalPercent > 0 ? ' (' + totalPercent + '% off ' + formatMoney(total) + ')' : '')
          : '';
      }
      updateAddToCartLabel();
    }

    // Remembers each row position's garment/size choice across Crew Deal switches,
    // so picking #1..#3 in "Crew Deal 1" then switching to "Crew Deal 2" and back doesn't reset them.
    var rowSelections = [];

    function buildRows(count) {
      if (!rowsContainer || !template) return;

      rowsContainer.querySelectorAll('.cpf-combo-row').forEach(function (row, i) {
        var g = row.querySelector('[data-row-garment]');
        var s = row.querySelector('[data-row-size]');
        rowSelections[i] = { garment: g ? g.value : null, size: s ? s.value : null };
      });

      rowsContainer.innerHTML = '';
      for (var i = 1; i <= count; i++) {
        var frag = template.content.cloneNode(true);
        var numEl = frag.querySelector('.cpf-combo-row__num');
        var garmentSelect = frag.querySelector('[data-row-garment]');
        var sizeSelect = frag.querySelector('[data-row-size]');
        numEl.textContent = '#' + i;

        var saved = rowSelections[i - 1];
        if (saved) {
          if (garmentSelect && saved.garment) garmentSelect.value = saved.garment;
          if (sizeSelect && saved.size) sizeSelect.value = saved.size;
        }

        if (garmentSelect) garmentSelect.addEventListener('change', updateRowPricing);
        if (sizeSelect) sizeSelect.addEventListener('change', updateRowPricing);
        if (sizeSelect && sizeAllSelect) sizeSelect.addEventListener('change', syncSizeAllFromRows);
        rowsContainer.appendChild(frag);
      }
      // "Same size for all": new rows (e.g. after switching packs) follow the chosen size too.
      if (sizeAllBlock) sizeAllBlock.hidden = count <= 1;
      if (sizeAllSelect && sizeAllSelect.value) setAllRowSizes(sizeAllSelect.value);
      updateRowPricing();
    }

    // "Same size for all" picker (optional, per template): sets every row's size at once, and
    // flips back to "Mixed sizes" as soon as one row is changed to something different.
    var sizeAllBlock = comboEl.querySelector('[data-size-all]');
    var sizeAllSelect = comboEl.querySelector('[data-size-all-select]');
    function setAllRowSizes(value) {
      rowsContainer.querySelectorAll('[data-row-size]').forEach(function (sel) {
        if ([].some.call(sel.options, function (o) { return o.value === value; })) sel.value = value;
      });
    }
    function syncSizeAllFromRows() {
      var sizes = [].map.call(rowsContainer.querySelectorAll('[data-row-size]'), function (sel) { return sel.value; });
      var allSame = sizes.length && sizes.every(function (v) { return v === sizes[0]; });
      sizeAllSelect.value = allSame ? sizes[0] : '';
    }
    if (sizeAllSelect) {
      sizeAllSelect.addEventListener('change', function () {
        if (!sizeAllSelect.value) return;
        setAllRowSizes(sizeAllSelect.value);
        updateRowPricing();
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.checked) buildRows(parseInt(this.getAttribute('data-combo-count'), 10));
      });
    });

    // Live price / "you save" / next-discount hint on every Crew Deal card, driven by the
    // product's base price and each card's data-combo-count + data-combo-percent. Tier
    // thresholds here (3/5/10 → 3/5/8%) mirror CREW_TIERS below — keep both in sync if the
    // deal structure ever changes.
    var basePriceCents = parseInt(cpfRoot.getAttribute('data-base-price'), 10) || 0;
    var comboCardTiers = [
      { min: 3, percent: 3 },
      { min: 5, percent: 5 },
      { min: 10, percent: 8 }
    ];
    // Per-template override (e.g. Ornament: 5/10/15/20 → 5/8/12/15%) from the snippet.
    try {
      var tiersAttr = cpfRoot.getAttribute('data-combo-tiers');
      if (tiersAttr) comboCardTiers = JSON.parse(tiersAttr);
    } catch (e) {}

    function updateComboCardPricing() {
      comboEl.querySelectorAll('.cpf-combo-card').forEach(function (card) {
        var input = card.querySelector('input[type="radio"]');
        if (!input) return;
        var count = parseInt(input.getAttribute('data-combo-count'), 10) || 1;
        var percent = parseFloat(input.getAttribute('data-combo-percent')) || 0;
        var compareTotal = basePriceCents * count;
        // Per-unit discount rounded down to the cent, same as Shopify's checkout.
        var discountedTotal = (basePriceCents - Math.floor(basePriceCents * percent / 100)) * count;
        var priceEl = card.querySelector('[data-combo-card-price]');
        var compareEl = card.querySelector('[data-combo-card-compare]');
        var saveEl = card.querySelector('[data-combo-card-save]');
        if (priceEl) priceEl.textContent = formatMoney(discountedTotal);
        if (compareEl) {
          compareEl.hidden = percent <= 0;
          compareEl.textContent = percent > 0 ? formatMoney(compareTotal) : '';
        }
        if (saveEl) saveEl.textContent = percent > 0 ? 'You save ' + formatMoney(compareTotal - discountedTotal) : '';
      });
    }

    var customRadio = comboEl.querySelector('[data-combo-custom-radio]');
    var customValueEl = comboEl.querySelector('[data-combo-custom-value]');
    var customCountEl = comboEl.querySelector('[data-combo-custom-count]');
    var customHintEl = comboEl.querySelector('.cpf-combo-card--custom [data-combo-card-hint]');
    var CUSTOM_MIN_QTY = 1;
    var CUSTOM_MAX_QTY = parseInt(cpfRoot.getAttribute('data-custom-max'), 10) || 50;

    function updateCustomHint(qty) {
      var sorted = comboCardTiers.slice().sort(function (a, b) { return a.min - b.min; });
      var currentPercent = 0;
      sorted.forEach(function (t) { if (qty >= t.min) currentPercent = t.percent; });
      var next = sorted.find(function (t) { return t.min > qty; });
      if (customRadio) customRadio.setAttribute('data-combo-percent', currentPercent);
      if (customHintEl) {
        customHintEl.textContent = next
          ? 'Add ' + (next.min - qty) + ' more for ' + next.percent + '% off'
          : "You've unlocked our best discount!";
      }
    }

    function setCustomQty(qty) {
      qty = Math.max(CUSTOM_MIN_QTY, Math.min(CUSTOM_MAX_QTY, qty));
      if (customRadio) customRadio.setAttribute('data-combo-count', qty);
      if (customValueEl) customValueEl.textContent = qty;
      if (customCountEl) customCountEl.textContent = '(' + qty + (qty === 1 ? ' item' : ' items') + ')';
      updateCustomHint(qty);
      updateComboCardPricing();
      if (customRadio && customRadio.checked) buildRows(qty);
    }

    var customMinusBtn = comboEl.querySelector('[data-combo-custom-minus]');
    var customPlusBtn = comboEl.querySelector('[data-combo-custom-plus]');
    if (customMinusBtn) {
      customMinusBtn.addEventListener('click', function () {
        var qty = parseInt(customRadio.getAttribute('data-combo-count'), 10) || CUSTOM_MIN_QTY;
        // A click on a button nested inside the <label> does NOT implicitly check the radio
        // (browsers only do that for clicks on the label's plain text/whitespace), so set it
        // explicitly — this also auto-unchecks the other Crew Deal radios (same name group).
        if (customRadio) customRadio.checked = true;
        setCustomQty(qty - 1);
      });
    }
    if (customPlusBtn) {
      customPlusBtn.addEventListener('click', function () {
        var qty = parseInt(customRadio.getAttribute('data-combo-count'), 10) || CUSTOM_MIN_QTY;
        if (customRadio) customRadio.checked = true;
        setCustomQty(qty + 1);
      });
    }
    if (customRadio) updateCustomHint(parseInt(customRadio.getAttribute('data-combo-count'), 10) || CUSTOM_MIN_QTY);
    updateComboCardPricing();

    // "Sleeve flag" picker — live caption showing the currently selected flag's name. The
    // selection itself is already captured as a line item property via data-cpf-radio-field,
    // same mechanism as the "Do you have a logo?" question, so it shows correctly in the
    // cart, checkout, and order details.
    var flagLabelEl = cpfRoot.querySelector('[data-flag-selected-label]');
    cpfRoot.querySelectorAll('input[data-cpf-radio-field="Sleeve Flag"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (flagLabelEl && input.checked) flagLabelEl.textContent = input.value;
      });
    });

    // Optional 3rd logo answer ("no logo needed") — hide the upload box while it's selected.
    var uploadBlock = cpfRoot.querySelector('[data-cpf-upload-block]');
    var logoNoneInput = cpfRoot.querySelector('[data-cpf-logo-none]');
    if (uploadBlock && logoNoneInput) {
      cpfRoot.querySelectorAll('input[name="' + logoNoneInput.name + '"]').forEach(function (input) {
        input.addEventListener('change', function () {
          uploadBlock.hidden = logoNoneInput.checked;
        });
      });
    }

    var checked = comboEl.querySelector('[data-combo-count]:checked');
    if (checked) buildRows(parseInt(checked.getAttribute('data-combo-count'), 10));
  });

  /* ============ AJAX add to cart — one cart LINE per crew row (#1..#N), each its own price ============ */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var cpfRoot = productForm.querySelector('.custom-product-form');
      var messageEl = productForm.querySelector('[data-form-message]');
      var addBtn = productForm.querySelector('[data-add-to-cart]');
      var qtyInput = productForm.querySelector('[data-qty-input]');
      var sets = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

      var rows = cpfRoot ? cpfRoot.querySelectorAll('.cpf-combo-row[data-variant-id]') : [];

      if (!rows.length) {
        if (messageEl) { messageEl.textContent = 'Please choose a garment and size for each item.'; messageEl.className = 'product-form__message is-error'; }
        return;
      }

      // Collect shared / common line item properties (company, phone, design notes, logo Q&A)
      var sharedProperties = {};
      cpfRoot.querySelectorAll('[data-cpf-field]').forEach(function (input) {
        var key = input.getAttribute('data-cpf-field');
        if (input.value) sharedProperties[key] = input.value;
      });
      cpfRoot.querySelectorAll('[data-cpf-radio-field]:checked').forEach(function (input) {
        var key = input.getAttribute('data-cpf-radio-field');
        sharedProperties[key] = input.value;
      });
      // Hidden tag so the cart can apply this product group's own tier codes (see ORNAMENT_TIERS).
      var tierGroup = cpfRoot.getAttribute('data-tier-group');
      if (tierGroup && tierGroup !== 'crew') sharedProperties._tier_group = tierGroup;
      var fileInput = cpfRoot.querySelector('[data-cpf-file-field]');
      var fileKey = fileInput ? fileInput.getAttribute('data-cpf-file-field') : null;
      var file = (fileInput && fileInput.files && fileInput.files[0]) ? fileInput.files[0] : null;
      var uploadBlockEl = cpfRoot.querySelector('[data-cpf-upload-block]');
      if (uploadBlockEl && uploadBlockEl.hidden) file = null;

      if (addBtn) addBtn.disabled = true;
      if (messageEl) { messageEl.textContent = 'Adding ' + rows.length + ' item(s) to cart…'; messageEl.className = 'product-form__message'; }

      // Rows picking the same variant become one line with a summed quantity (Shopify merges
      // identical variant+properties lines anyway), and everything goes in as few requests as
      // possible: one JSON /cart/add.js with every line, plus — only when a logo was attached —
      // one FormData request first to upload the file once. Its returned URL is then reused as
      // the property value on every other line, instead of re-uploading it per row.
      var groups = [];
      var groupByVariant = {};
      rows.forEach(function (row) {
        var variantId = row.getAttribute('data-variant-id');
        if (!groupByVariant[variantId]) {
          groupByVariant[variantId] = { id: parseInt(variantId, 10), quantity: 0, properties: Object.assign({}, sharedProperties) };
          groups.push(groupByVariant[variantId]);
        }
        groupByVariant[variantId].quantity += sets;
      });

      // Matching Hat upsell rides along in the same batch, using whatever quantity is set in
      // the banner/popup stepper (they're kept in sync — see setHatAddonQty).
      var hatBanner = document.querySelector('[data-hat-addon-banner]');
      var hatQtyInput = document.querySelector('[data-hat-addon-qty]');
      var hatQty = hatQtyInput ? parseInt(hatQtyInput.value, 10) || 0 : 0;
      var hatVariantId = hatBanner ? hatBanner.getAttribute('data-hat-addon-variant-id') : null;

      var failures = [];
      function readAddResult(r) {
        return r.json().then(function (data) {
          if (!r.ok) failures.push((data && data.description) || 'Could not add an item.');
          return data;
        });
      }

      var chain = Promise.resolve();
      if (file && fileKey) {
        var first = groups.shift();
        chain = chain.then(function () {
          var formData = new FormData();
          formData.append('id', first.id);
          formData.append('quantity', first.quantity);
          Object.keys(first.properties).forEach(function (key) {
            formData.append('properties[' + key + ']', first.properties[key]);
          });
          formData.append('properties[' + fileKey + ']', file);
          return fetch('/cart/add.js', { method: 'POST', body: formData }).then(readAddResult);
        }).then(function (item) {
          var fileUrl = item && item.properties && item.properties[fileKey];
          if (typeof fileUrl === 'string' && fileUrl) {
            groups.forEach(function (g) { g.properties[fileKey] = fileUrl; });
          }
        });
      }

      chain = chain.then(function () {
        if (failures.length) return;
        var items = groups.slice();
        if (hatQty > 0 && hatVariantId) {
          items.push({ id: parseInt(hatVariantId, 10), quantity: hatQty, properties: { _addon: 'hat' } });
        }
        if (!items.length) return;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(readAddResult);
      }).catch(function () { failures.push('Network error adding items.'); });

      chain.then(function () {
        if (addBtn) addBtn.disabled = false;
        if (failures.length === 0) {
          if (messageEl) { messageEl.textContent = 'Added to cart!'; messageEl.className = 'product-form__message is-success'; }
          // refreshCartDrawer() re-fetches the cart and re-renders it, which also runs
          // syncCartPerks() — that's what checks the TOTAL cart quantity and applies the
          // right tier discount / free ebook, regardless of which deal was picked here.
          refreshCartDrawer().then(openCartDrawer);
        } else {
          if (messageEl) { messageEl.textContent = failures.join(' '); messageEl.className = 'product-form__message is-error'; }
          refreshCartDrawer();
        }
      });
    });
  }

  /* ============ Size chart modal: open/close, garment tabs, inches/cm toggle ============ */
  var sizeChartModal = document.getElementById('size-chart-modal');
  if (sizeChartModal) {
    var sizeChartOpeners = document.querySelectorAll('[data-open-size-chart]');
    var sizeChartClosers = sizeChartModal.querySelectorAll('[data-size-chart-close]');
    var sizeChartTabs = sizeChartModal.querySelectorAll('.size-chart-tab');
    var sizeChartPanels = sizeChartModal.querySelectorAll('.size-chart-panel');
    var sizeChartUnitButtons = sizeChartModal.querySelectorAll('.size-chart-unit');
    var sizeChartCells = sizeChartModal.querySelectorAll('.size-chart-table td[data-inch]');

    function openSizeChart() { sizeChartModal.setAttribute('aria-hidden', 'false'); }
    function closeSizeChart() { sizeChartModal.setAttribute('aria-hidden', 'true'); }

    sizeChartOpeners.forEach(function (el) { el.addEventListener('click', openSizeChart); });
    sizeChartClosers.forEach(function (el) { el.addEventListener('click', closeSizeChart); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sizeChartModal.getAttribute('aria-hidden') === 'false') closeSizeChart();
    });

    sizeChartTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-size-chart-tab');
        sizeChartTabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        sizeChartPanels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-size-chart-panel') === index);
        });
      });
    });

    sizeChartUnitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-unit');
        sizeChartUnitButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        sizeChartCells.forEach(function (cell) {
          var inchVal = parseFloat(cell.getAttribute('data-inch'));
          if (isNaN(inchVal)) return;
          cell.textContent = unit === 'cm' ? Math.round(inchVal * 2.54 * 10) / 10 : cell.getAttribute('data-inch');
        });
      });
    });
  }

  /* ============ Bonus eBook popup: open/close + "Read more" clamp toggle ============ */
  var ebookModal = document.getElementById('ebook-bonus-modal');
  if (ebookModal) {
    var ebookOpeners = document.querySelectorAll('[data-open-ebook-bonus]');
    var ebookClosers = ebookModal.querySelectorAll('[data-ebook-modal-close]');

    function openEbookModal() { ebookModal.setAttribute('aria-hidden', 'false'); }
    function closeEbookModal() { ebookModal.setAttribute('aria-hidden', 'true'); }

    ebookOpeners.forEach(function (el) { el.addEventListener('click', openEbookModal); });
    ebookClosers.forEach(function (el) { el.addEventListener('click', closeEbookModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ebookModal.getAttribute('aria-hidden') === 'false') closeEbookModal();
    });

    ebookModal.querySelectorAll('.ebook-card').forEach(function (card) {
      var review = card.querySelector('[data-ebook-review]');
      var moreBtn = card.querySelector('[data-ebook-more]');
      if (!review || !moreBtn) return;
      if (review.scrollHeight > review.clientHeight + 1) {
        moreBtn.hidden = false;
        moreBtn.addEventListener('click', function () {
          var expanded = review.classList.toggle('is-expanded');
          moreBtn.textContent = expanded ? 'Read less' : 'Read more';
        });
      }
    });
  }

  /* ============ Sample product video popup: plays on open, pauses on close ============ */
  var sampleVideoModal = document.getElementById('sample-video-modal');
  if (sampleVideoModal) {
    var sampleVideo = sampleVideoModal.querySelector('video');
    function openSampleVideo() {
      sampleVideoModal.setAttribute('aria-hidden', 'false');
      if (sampleVideo) { var p = sampleVideo.play(); if (p && p.catch) p.catch(function () {}); }
    }
    function closeSampleVideo() {
      sampleVideoModal.setAttribute('aria-hidden', 'true');
      if (sampleVideo) sampleVideo.pause();
    }
    document.querySelectorAll('[data-open-sample-video]').forEach(function (el) { el.addEventListener('click', openSampleVideo); });
    sampleVideoModal.querySelectorAll('[data-sample-video-close]').forEach(function (el) { el.addEventListener('click', closeSampleVideo); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sampleVideoModal.getAttribute('aria-hidden') === 'false') closeSampleVideo();
    });
  }

  /* ============ "How to Order" guide popup: open/close + swipeable step carousel ============ */
  var orderGuideModal = document.getElementById('order-guide-modal');
  if (orderGuideModal) {
    var orderGuideOpeners = document.querySelectorAll('[data-open-order-guide]');
    var orderGuideClosers = orderGuideModal.querySelectorAll('[data-order-guide-close]');
    var orderGuideTrack = orderGuideModal.querySelector('[data-order-guide-track]');
    var orderGuideSlides = orderGuideModal.querySelectorAll('[data-order-guide-slide]');
    var orderGuidePrev = orderGuideModal.querySelector('[data-order-guide-prev]');
    var orderGuideNext = orderGuideModal.querySelector('[data-order-guide-next]');
    var orderGuideDots = orderGuideModal.querySelectorAll('[data-order-guide-dot]');

    function openOrderGuide() { orderGuideModal.setAttribute('aria-hidden', 'false'); }
    function closeOrderGuide() { orderGuideModal.setAttribute('aria-hidden', 'true'); }

    orderGuideOpeners.forEach(function (el) { el.addEventListener('click', openOrderGuide); });
    orderGuideClosers.forEach(function (el) { el.addEventListener('click', closeOrderGuide); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && orderGuideModal.getAttribute('aria-hidden') === 'false') closeOrderGuide();
    });

    function goToOrderGuideStep(index) {
      if (!orderGuideTrack || !orderGuideSlides[index]) return;
      orderGuideTrack.scrollTo({ left: orderGuideSlides[index].offsetLeft, behavior: 'smooth' });
    }

    if (orderGuidePrev) orderGuidePrev.addEventListener('click', function () {
      var current = Math.round(orderGuideTrack.scrollLeft / orderGuideTrack.clientWidth);
      goToOrderGuideStep(Math.max(0, current - 1));
    });
    if (orderGuideNext) orderGuideNext.addEventListener('click', function () {
      var current = Math.round(orderGuideTrack.scrollLeft / orderGuideTrack.clientWidth);
      goToOrderGuideStep(Math.min(orderGuideSlides.length - 1, current + 1));
    });
    orderGuideDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToOrderGuideStep(parseInt(dot.getAttribute('data-order-guide-dot'), 10));
      });
    });

    if (orderGuideTrack) {
      orderGuideTrack.addEventListener('scroll', function () {
        var current = Math.round(orderGuideTrack.scrollLeft / (orderGuideTrack.clientWidth || 1));
        orderGuideDots.forEach(function (dot) {
          dot.classList.toggle('is-active', parseInt(dot.getAttribute('data-order-guide-dot'), 10) === current);
        });
      });

      // Drag-to-scroll for both mouse and touch (same approach as the product gallery/testimonials),
      // snapping to the nearest step once the drag ends.
      var orderGuideDragging = false;
      var orderGuideDragStartX = 0;
      var orderGuideDragStartScrollLeft = 0;
      var orderGuideDidDrag = false;

      orderGuideTrack.addEventListener('pointerdown', function (e) {
        orderGuideDragging = true;
        orderGuideDidDrag = false;
        orderGuideDragStartX = e.clientX;
        orderGuideDragStartScrollLeft = orderGuideTrack.scrollLeft;
        orderGuideTrack.classList.add('is-dragging');
        orderGuideTrack.setPointerCapture(e.pointerId);
      });
      orderGuideTrack.addEventListener('pointermove', function (e) {
        if (!orderGuideDragging) return;
        var dx = e.clientX - orderGuideDragStartX;
        if (Math.abs(dx) > 3) orderGuideDidDrag = true;
        orderGuideTrack.scrollLeft = orderGuideDragStartScrollLeft - dx;
      });
      function endOrderGuideDrag() {
        if (!orderGuideDragging) return;
        orderGuideDragging = false;
        orderGuideTrack.classList.remove('is-dragging');
        var nearest = Math.round(orderGuideTrack.scrollLeft / (orderGuideTrack.clientWidth || 1));
        goToOrderGuideStep(Math.max(0, Math.min(orderGuideSlides.length - 1, nearest)));
      }
      orderGuideTrack.addEventListener('pointerup', endOrderGuideDrag);
      orderGuideTrack.addEventListener('pointercancel', endOrderGuideDrag);
      orderGuideTrack.addEventListener('pointerleave', function () { if (orderGuideDragging) endOrderGuideDrag(); });
      orderGuideTrack.addEventListener('click', function (e) {
        if (orderGuideDidDrag) { e.preventDefault(); e.stopPropagation(); orderGuideDidDrag = false; }
      }, true);
    }
  }

  /* ============ Matching Hat upsell popup: open/close + swipeable image carousel (same pattern
     as the How to Order guide above) ============ */
  var hatAddonModal = document.getElementById('hat-addon-modal');
  if (hatAddonModal) {
    var hatAddonOpeners = document.querySelectorAll('[data-open-hat-addon]');
    var hatAddonClosers = hatAddonModal.querySelectorAll('[data-hat-addon-close]');
    var hatAddonTrack = hatAddonModal.querySelector('[data-hat-addon-track]');
    var hatAddonSlides = hatAddonModal.querySelectorAll('[data-hat-addon-slide]');
    var hatAddonPrev = hatAddonModal.querySelector('[data-hat-addon-prev]');
    var hatAddonNext = hatAddonModal.querySelector('[data-hat-addon-next]');
    var hatAddonDots = hatAddonModal.querySelectorAll('[data-hat-addon-dot]');

    function openHatAddon() { hatAddonModal.setAttribute('aria-hidden', 'false'); }
    function closeHatAddon() { hatAddonModal.setAttribute('aria-hidden', 'true'); }

    hatAddonOpeners.forEach(function (el) { el.addEventListener('click', openHatAddon); });
    hatAddonClosers.forEach(function (el) { el.addEventListener('click', closeHatAddon); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && hatAddonModal.getAttribute('aria-hidden') === 'false') closeHatAddon();
    });

    function goToHatAddonSlide(index) {
      if (!hatAddonTrack || !hatAddonSlides[index]) return;
      hatAddonTrack.scrollTo({ left: hatAddonSlides[index].offsetLeft, behavior: 'smooth' });
    }

    if (hatAddonPrev) hatAddonPrev.addEventListener('click', function () {
      var current = Math.round(hatAddonTrack.scrollLeft / hatAddonTrack.clientWidth);
      goToHatAddonSlide(Math.max(0, current - 1));
    });
    if (hatAddonNext) hatAddonNext.addEventListener('click', function () {
      var current = Math.round(hatAddonTrack.scrollLeft / hatAddonTrack.clientWidth);
      goToHatAddonSlide(Math.min(hatAddonSlides.length - 1, current + 1));
    });
    hatAddonDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToHatAddonSlide(parseInt(dot.getAttribute('data-hat-addon-dot'), 10));
      });
    });

    if (hatAddonTrack) {
      hatAddonTrack.addEventListener('scroll', function () {
        var current = Math.round(hatAddonTrack.scrollLeft / (hatAddonTrack.clientWidth || 1));
        hatAddonDots.forEach(function (dot) {
          dot.classList.toggle('is-active', parseInt(dot.getAttribute('data-hat-addon-dot'), 10) === current);
        });
      });

      var hatAddonDragging = false;
      var hatAddonDragStartX = 0;
      var hatAddonDragStartScrollLeft = 0;
      var hatAddonDidDrag = false;

      hatAddonTrack.addEventListener('pointerdown', function (e) {
        hatAddonDragging = true;
        hatAddonDidDrag = false;
        hatAddonDragStartX = e.clientX;
        hatAddonDragStartScrollLeft = hatAddonTrack.scrollLeft;
        hatAddonTrack.classList.add('is-dragging');
        hatAddonTrack.setPointerCapture(e.pointerId);
      });
      hatAddonTrack.addEventListener('pointermove', function (e) {
        if (!hatAddonDragging) return;
        var dx = e.clientX - hatAddonDragStartX;
        if (Math.abs(dx) > 3) hatAddonDidDrag = true;
        hatAddonTrack.scrollLeft = hatAddonDragStartScrollLeft - dx;
      });
      function endHatAddonDrag() {
        if (!hatAddonDragging) return;
        hatAddonDragging = false;
        hatAddonTrack.classList.remove('is-dragging');
        var nearest = Math.round(hatAddonTrack.scrollLeft / (hatAddonTrack.clientWidth || 1));
        goToHatAddonSlide(Math.max(0, Math.min(hatAddonSlides.length - 1, nearest)));
      }
      hatAddonTrack.addEventListener('pointerup', endHatAddonDrag);
      hatAddonTrack.addEventListener('pointercancel', endHatAddonDrag);
      hatAddonTrack.addEventListener('pointerleave', function () { if (hatAddonDragging) endHatAddonDrag(); });
      hatAddonTrack.addEventListener('click', function (e) {
        if (hatAddonDidDrag) { e.preventDefault(); e.stopPropagation(); hatAddonDidDrag = false; }
      }, true);
    }
  }

  /* ============ Matching Hat upsell quantity: the banner's stepper and the popup's stepper share
     the exact same data attributes, so keeping them in sync is just "update every matching
     element" instead of tracking two separate states. ============ */
  var hatAddonBanner = document.querySelector('[data-hat-addon-banner]');
  if (hatAddonBanner) {
    var HAT_ADDON_MAX = 50;
    function setHatAddonQty(qty) {
      qty = Math.max(0, Math.min(HAT_ADDON_MAX, parseInt(qty, 10) || 0));
      document.querySelectorAll('[data-hat-addon-qty]').forEach(function (input) { input.value = qty; });
      return qty;
    }
    document.querySelectorAll('[data-hat-addon-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = parseInt((document.querySelector('[data-hat-addon-qty]') || {}).value, 10) || 0;
        setHatAddonQty(current - 1);
      });
    });
    document.querySelectorAll('[data-hat-addon-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = parseInt((document.querySelector('[data-hat-addon-qty]') || {}).value, 10) || 0;
        setHatAddonQty(current + 1);
      });
    });
    document.querySelectorAll('[data-hat-addon-qty]').forEach(function (input) {
      input.addEventListener('input', function () { setHatAddonQty(input.value); });
    });
  }

  /* ============ Apply a discount code to the visitor's cart via Shopify's native /discount/CODE
     route. This route sets X-Frame-Options: DENY, so it can't be loaded silently in a hidden
     iframe — a real (top-level) redirect through it and back is the only way to actually apply
     the code, rather than just displaying it as text to copy. Delayed a few seconds so the visitor
     has time to read the success message / copy the code first. ============ */
  function autoApplyDiscount(stepEl, delayMs) {
    if (!stepEl) return;
    var code = stepEl.getAttribute('data-discount-code');
    if (!code) return;
    setTimeout(function () {
      var returnTo = window.location.pathname + window.location.search;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(returnTo);
    }, delayMs || 3000);
  }

  /* ============ Email popup ($ off first order): timed show, dismiss memory, copy code ============ */
  var emailPopup = document.getElementById('email-popup');
  if (emailPopup) {
    var EMAIL_POPUP_STORAGE_KEY = 'emailPopupHideUntil';
    var frequencyDays = parseFloat(emailPopup.getAttribute('data-frequency-days')) || 7;
    var delaySeconds = parseFloat(emailPopup.getAttribute('data-delay')) || 5;

    function openEmailPopup() { emailPopup.setAttribute('aria-hidden', 'false'); }
    function hideEmailPopupForNow() {
      emailPopup.setAttribute('aria-hidden', 'true');
      var hideUntil = Date.now() + frequencyDays * 24 * 60 * 60 * 1000;
      try { localStorage.setItem(EMAIL_POPUP_STORAGE_KEY, String(hideUntil)); } catch (e) {}
    }

    emailPopup.querySelectorAll('[data-email-popup-close]').forEach(function (el) {
      el.addEventListener('click', hideEmailPopupForNow);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && emailPopup.getAttribute('aria-hidden') === 'false') hideEmailPopupForNow();
    });

    var emailPopupSuccessStep = emailPopup.querySelector('[data-email-popup-step="success"]');

    if (emailPopupSuccessStep && window.location.hash === '#EmailPopupForm') {
      // Page just reloaded after a successful signup (Shopify redirects back here with this
      // hash and form.posted_successfully? true) — reopen showing the success step, and
      // remember to not show the popup again for a while.
      openEmailPopup();
      try { localStorage.setItem(EMAIL_POPUP_STORAGE_KEY, String(Date.now() + frequencyDays * 24 * 60 * 60 * 1000)); } catch (err) {}
      autoApplyDiscount(emailPopupSuccessStep, 1500);
    } else {
      var hideUntilStored = 0;
      try { hideUntilStored = parseInt(localStorage.getItem(EMAIL_POPUP_STORAGE_KEY), 10) || 0; } catch (e) {}
      if (Date.now() > hideUntilStored) {
        setTimeout(openEmailPopup, delaySeconds * 1000);
      }
    }

    var copyBtn = emailPopup.querySelector('[data-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-copy-code');
        var done = function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copied!';
          copyBtn.classList.add('is-copied');
          setTimeout(function () { copyBtn.textContent = original; copyBtn.classList.remove('is-copied'); }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    }
  }

  /* ============ Sticky $ off bar (page-specific, e.g. Collections page) ============ */
  var stickyOfferModal = document.getElementById('sticky-offer-modal');
  var stickyOfferBar = document.querySelector('[data-sticky-offer-open]');
  if (stickyOfferModal && stickyOfferBar) {
    function openStickyOffer() { stickyOfferModal.setAttribute('aria-hidden', 'false'); }
    function closeStickyOffer() { stickyOfferModal.setAttribute('aria-hidden', 'true'); }

    stickyOfferBar.addEventListener('click', openStickyOffer);
    stickyOfferModal.querySelectorAll('[data-sticky-offer-close]').forEach(function (el) {
      el.addEventListener('click', closeStickyOffer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && stickyOfferModal.getAttribute('aria-hidden') === 'false') closeStickyOffer();
    });

    var stickySuccessStep = stickyOfferModal.querySelector('[data-sticky-offer-step="success"]');
    if (stickySuccessStep && window.location.hash === '#StickyOfferForm') {
      // Page just reloaded after a successful signup (Shopify redirects back here with this
      // hash and form.posted_successfully? true) — reopen showing the success step.
      openStickyOffer();
      autoApplyDiscount(stickySuccessStep, 1500);
    }

    var stickyCopyBtn = stickyOfferModal.querySelector('[data-copy-code]');
    if (stickyCopyBtn) {
      stickyCopyBtn.addEventListener('click', function () {
        var code = stickyCopyBtn.getAttribute('data-copy-code');
        var done = function () {
          var original = stickyCopyBtn.textContent;
          stickyCopyBtn.textContent = 'Copied!';
          stickyCopyBtn.classList.add('is-copied');
          setTimeout(function () { stickyCopyBtn.textContent = original; stickyCopyBtn.classList.remove('is-copied'); }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    }
  }

  /* ============ Generic drag-to-scroll for horizontal tile rows (Shop by Design style tiles,
     on both the homepage/product-page section and the dedicated filter page) — same
     mouse+touch approach as the testimonials carousel. ============ */
  document.querySelectorAll('[data-drag-scroll]').forEach(function (scroller) {
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var didDrag = false;

    scroller.addEventListener('pointerdown', function (e) {
      isDragging = true;
      didDrag = false;
      dragStartX = e.clientX;
      dragStartScrollLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
    });
    scroller.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 3) {
        // Only capture the pointer once an actual drag is confirmed — capturing
        // eagerly on every pointerdown retargets the compatibility click event
        // to the scroller itself, so plain clicks on tiles/buttons never reach them.
        if (!didDrag) scroller.setPointerCapture(e.pointerId);
        didDrag = true;
      }
      scroller.scrollLeft = dragStartScrollLeft - dx;
    });
    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      scroller.classList.remove('is-dragging');
    }
    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('pointerleave', function () { if (isDragging) endDrag(); });
    // Suppress the click/tap-through on a tile (link or filter button) right after a drag.
    scroller.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);
  });

  /* ============ Shop by Design Style page: filter the combined product grid by style tile ============ */
  document.querySelectorAll('[data-style-filters]').forEach(function (filterBar) {
    var page = filterBar.closest('.shop-by-style-page');
    var grid = page ? page.querySelector('[data-style-product-grid]') : null;
    var emptyMsg = page ? page.querySelector('[data-style-empty]') : null;
    if (!grid) return;
    var buttons = filterBar.querySelectorAll('[data-style-filter]');
    var items = grid.querySelectorAll('[data-style-product]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-style-filter');
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        var visibleCount = 0;
        items.forEach(function (item) {
          var matches = filter === 'all' || (item.getAttribute('data-styles') || '').split(' ').indexOf(filter) !== -1;
          item.hidden = !matches;
          if (matches) visibleCount++;
        });
        if (emptyMsg) emptyMsg.hidden = visibleCount > 0;
      });
    });
  });

  /* ============ Size chart page: garment tabs + inches/cm toggle (same logic as the modal) ============ */
  var sizeChartPage = document.querySelector('.size-chart-page');
  if (sizeChartPage) {
    var scpTabs = sizeChartPage.querySelectorAll('.size-chart-tab');
    var scpPanels = sizeChartPage.querySelectorAll('.size-chart-panel');
    var scpUnitButtons = sizeChartPage.querySelectorAll('.size-chart-unit');
    var scpCells = sizeChartPage.querySelectorAll('.size-chart-table td[data-inch]');

    scpTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-size-chart-tab');
        scpTabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        scpPanels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-size-chart-panel') === index);
        });
      });
    });

    scpUnitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-unit');
        scpUnitButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        scpCells.forEach(function (cell) {
          var inchVal = parseFloat(cell.getAttribute('data-inch'));
          if (isNaN(inchVal)) return;
          cell.textContent = unit === 'cm' ? Math.round(inchVal * 2.54 * 10) / 10 : cell.getAttribute('data-inch');
        });
      });
    });
  }

  /* ============ Hero slideshow: autoplay + dots + arrows ============ */
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    if (slides.length < 2) return;

    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseFloat(root.getAttribute('data-autoplay-speed')) || 6) * 1000;
    var timer = null;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }
    function stopAutoplay() { if (timer) clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // Swipe/drag (mouse and touch) to change slides.
    var dragStartX = 0;
    var isDragging = false;
    root.addEventListener('pointerdown', function (e) {
      isDragging = true;
      dragStartX = e.clientX;
      stopAutoplay();
    });
    root.addEventListener('pointerup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var dx = e.clientX - dragStartX;
      if (dx < -40) goTo(current + 1);
      else if (dx > 40) goTo(current - 1);
      startAutoplay();
    });
    root.addEventListener('pointercancel', function () { isDragging = false; startAutoplay(); });

    startAutoplay();
  });

});
